import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs/operators';
import { FeatureFlagService } from 'src/app/services/new_services/feature-flag.service';

function siteIdOf(route: ActivatedRouteSnapshot, param: string): string | null {
  return route.paramMap.get(param) ?? route.parent?.paramMap.get(param) ?? null;
}

/**
 * Ferme l'ancien écran site tant que le nouveau front est actif :
 * /mysite/:id bascule alors vers /site/:id. Les sous-routes du site
 * (myprojects, myblasts, operations, dashboard) ne sont pas concernées.
 */
export const LegacySiteGuard: CanActivateFn = (route) => {
  const featureFlags = inject(FeatureFlagService);
  const router       = inject(Router);
  const siteId       = siteIdOf(route, 'id');
  if (siteId === null) { return true; }

  return featureFlags.resolveLegacySiteEnabled(siteId).pipe(
    map((legacyEnabled): boolean | UrlTree => {
      if (legacyEnabled) { return true; }
      return router.createUrlTree(['/site', siteId], { queryParams: route.queryParams });
    }),
  );
};

/**
 * Ferme le nouvel écran site tant que l'ancien front est actif :
 * /site/:siteId bascule alors vers /mysite/:siteId.
 */
export const NewSiteGuard: CanActivateFn = (route) => {
  const featureFlags = inject(FeatureFlagService);
  const router       = inject(Router);
  const siteId       = siteIdOf(route, 'siteId');
  if (siteId === null) { return true; }

  return featureFlags.resolveLegacySiteEnabled(siteId).pipe(
    map((legacyEnabled): boolean | UrlTree => {
      if (!legacyEnabled) { return true; }
      return router.createUrlTree(['/mysite', siteId], { queryParams: route.queryParams });
    }),
  );
};
